import { RefreshCw } from "lucide-react";

const TONE = { active: "text-emerald-300", cancelling: "text-amber-300", pending: "text-slate-400", cancelled: "text-rose-300", paused: "text-amber-300", deactivated: "text-rose-300" };
const day = (iso) => new Date(iso).toLocaleDateString();
const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

function PauseNote({ m }) {
  if (!m.pause) return null;
  const reward = m.pause.reason === "referral_reward";
  return (
    <span className={reward ? "text-[#FFD600]" : "text-amber-300"} data-testid={`member-pause-${m.membership_id}`}>
      {reward ? "Free month (referral)" : "Paused"} · skips {m.pause.pause_effective_date} → {m.pause.resume_effective_date}
    </span>
  );
}

export function MemberRow({ m, onSync }) {
  return (
    <div className="dg-card rounded-xl p-4 text-sm" data-testid={`member-row-${m.membership_id}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-display font-semibold">{m.name} <span className="text-slate-500 font-normal">· {m.tier_name} · ${Number(m.price_usd).toFixed(0)}/mo</span></div>
          <div className="text-slate-400 mt-1"><a href={`mailto:${m.email}`} className="dg-link">{m.email}</a>{m.phone && <> · <a href={`tel:${m.phone}`} className="dg-link">{m.phone}</a></>}</div>
        </div>
        <span className={`dg-chip ${TONE[m.status] || ""}`} data-testid={`member-status-${m.membership_id}`}>{m.status}</span>
      </div>
      <div className="text-xs text-slate-500 mt-2 flex flex-wrap gap-x-3 gap-y-1">
        <span>Since {day(m.activated_at || m.created_at)}</span>
        {m.charged_through_date && <span>Paid through {m.charged_through_date}</span>}
        {m.canceled_date && <span>Ends {m.canceled_date}</span>}
        {m.included_sessions?.length > 0 && <span>{plural(m.included_sessions.length, "included session")} used</span>}
        {m.last_checkin_at && <span>Check-in sent {day(m.last_checkin_at)}</span>}
        {m.last_nudge_at && <span>Session nudge {day(m.last_nudge_at)}</span>}
        <PauseNote m={m} />
        {m.referrals_count > 0 && <span>{plural(m.referrals_count, "referral")}</span>}
        {m.referred_by_name && <span>Referred by {m.referred_by_name}</span>}
        {m.reward_credits_pending > 0 && <span className="text-rose-300" data-testid={`member-credit-pending-${m.membership_id}`}>{m.reward_credits_pending} free month to apply manually</span>}
        <button type="button" onClick={() => onSync(m)} className="dg-link flex items-center gap-1 ml-auto" data-testid={`member-sync-${m.membership_id}`}><RefreshCw className="w-3 h-3" /> Sync</button>
      </div>
    </div>
  );
}
